<template>
    <section>
        <form @submit.prevent="next()" novalidate>
        <div class="t-headline5 mt3">
            {{$t('1608')}}
            <!-- 개인정보 입력 -->
        </div>
        <div class="t-body3 mt6 t-color-content1">
            {{$t('1609')}}
            <!-- 이름을 입력하세요. -->
        </div>
        <div class="mt38">
            
            <div class="mdc-text-field mdc-text-field--outlined w-full"
                :class="submitState && firstNameInvalidCheck ? 'mdc-text-field--invalid' : ''"
                id="firstNameEl"
            >
                <input type="text" class="mdc-text-field__input"
                    v-model="firstName"
                    v-validate="'required'"
                    ref="firstName"
                    id="firstName"
                    name="firstName"
                    maxlength="50"
                >
                <div class="mdc-notched-outline">
                    <div class="mdc-notched-outline__leading"></div>
                    <div class="mdc-notched-outline__notch">
                    <label for="tf-outlined" class="mdc-floating-label">{{$t('1610')}}</label>
                    </div>
                    <div class="mdc-notched-outline__trailing"></div>
                </div>
                
            </div>
            <div class="t-helper text-helper warning">
                <span v-show="submitState && firstNameInvalidCheck">
                    {{$t('951')}}
                </span>
            </div>

            <div class="mdc-text-field mdc-text-field--outlined w-full"
                :class="submitState && lastNameInvalidCheck ? 'mdc-text-field--invalid' : ''"
                id="lastNameEl"
            >
                <input type="text" class="mdc-text-field__input"
                    id="lastName"
                    name="lastName"
                    v-model="lastName"                            
                    v-validate="'required'"
                    ref="lastName"
                    maxlength="50"
                >
                <div class="mdc-notched-outline">
                    <div class="mdc-notched-outline__leading"></div>
                    <div class="mdc-notched-outline__notch">
                    <label for="tf-outlined" class="mdc-floating-label">{{$t('1611')}}</label>
                    </div>
                    <div class="mdc-notched-outline__trailing"></div>
                </div>
            </div>
            <div class="t-helper text-helper warning">
                <span v-show="submitState && lastNameInvalidCheck">
                    {{$t('952')}}
                </span>
            </div>

        </div>
        <div class="mt26 mb19">
            <button class="mdc-button mdc-button--raised btn-red mr8">
                {{$t('1612')}}
                <!-- 다음 -->
            </button>
            <button class="mdc-button btn-white" @click="cancelJoin()" type="button">
                {{$t('1613')}}
                <!-- 취소 -->
            </button>
        </div>

        
        </form>
    </section>
    
</template>

<script>
/**
 * 아이디 찾기 Step1 컴포넌트
 *
 * @author minkyoung.park@emcast.com
 * @author 
 * @since 2019.04
 */

// MDC Components 선언
import {MDCTextField} from '@material/textfield'
import {MDCRipple} from '@material/ripple'

// API 임포트
import findApi from '@/api/findApi.js'

// Store 임포트
import {mapState, mapMutations} from 'vuex'

import {joinMixin} from '@/mixins/join.js'

export default {
    data() {
        return {
            firstName: '',
            lastName: '',
            firstNameTextField: null,
            lastNameTextField: null,
            submitState: false
        }
    },

    mixins: [joinMixin],

    computed : {
        ...mapState('join',{
            join : state => state,
        }),
       
        // firstName 유효성 Check 및 아이콘
        firstNameInvalidCheck() {
            let returnValue = false
            if (this.submitState) {
                if (this.errors.has('firstName')) {
                    returnValue = true
                }else {
                    returnValue = false
                }
            }
            this.firstNameTextField.valid === !returnValue ? '' : this.firstNameTextField.valid = !returnValue
            return returnValue
        },

        // lastName 유효성 Check 및 아이콘
        lastNameInvalidCheck() {
            let returnValue = false
            if (this.submitState) {
                if (this.errors.has('lastName')) {
                    returnValue = true
                }else {
                    returnValue = false
                }
            }
            this.lastNameTextField.valid === !returnValue ? '' : this.lastNameTextField.valid = !returnValue
            return returnValue
        },
    },

    created() {
        if (!this.join.role || !this.join.responsibility  || !this.join.terms.TERMS_OF_SERVICE) {
            // this.$router.go(-1)
        }
    },

    mounted() {
        this.setMaterialUi()
        this.$refs.firstName.focus()
    },

    methods: {
        // Store 변이 정의
        ...mapMutations('join', ['SET_NAME_FIRST', 'SET_NAME_LAST', 'SET_NAME_FULL']),

        setMaterialUi() {
            this.firstNameTextField = new MDCTextField(document.querySelector('#firstNameEl'))
            this.firstNameTextField.useNativeValidation = false

            this.lastNameTextField = new MDCTextField(document.querySelector('#lastNameEl'))
            this.lastNameTextField.useNativeValidation = false

            const buttonRipple = [].map.call(document.querySelectorAll('.mdc-button'), function(el) {
                let button = new MDCRipple.attachTo(el)
                return button
            })

            this.firstName = this.join.name.first
            this.lastName = this.join.name.last
            this.firstNameTextField.value = this.firstName
            this.lastNameTextField.value = this.lastName
        },

        next() {
            this.$validator.validateAll().then((resultValid) => {
                this.submitState = true
                if (resultValid) {
                    this.SET_NAME_FIRST(this.firstName)
                    this.SET_NAME_LAST(this.lastName)
                    this.SET_NAME_FULL(this.firstName + ' ' + this.lastName)
                    
                    console.log('NEXT')
                    this.$router.push({name: 'JoinEmail'})                    
                } else{
                    this.focusFirstInvalidElement()
                }
            })
        }
    },

    

}
</script>

<style scoped>

</style>
